import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Ccr} from '../../../../core/models/Ccr';
import {Router} from '@angular/router';
import {CounterPartyComponent} from '../../../containers/counter-party/counter-party.component';

@Component({
    selector: 'app-wccr-box',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './wccr-box.component.html',
    styleUrls: ['./wccr-box.component.scss'],
    standalone: false
})
export class WccrBoxComponent implements OnInit {

    @Input()
    ccr: Ccr;

    @Input()
    boxTitle: string;

    @Input()
    boxClass: string;

    constructor(private router: Router) {
    }

    ngOnInit() {
    }

    onClick(legalEntityDataId, counterPartyName) {
        let url = '/counterParty/' + legalEntityDataId + '/' + counterPartyName;
        this.router.navigateByUrl(url);
    }

}
